module.exports = __webpack_public_path__ + "static/img/home_guankan.c3e6d4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home_guankan.png
// module id = Zi1j
// module chunks = 1